import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectIsAuthenticated } from "../../authentication/authenticationSlice";
import { selectCurrentLanguage } from "../../localization/localizationSlice";
import { updateInstructorLanguage } from "../slice-extensions/instructors-slice-extension";

/**
 * Mirrors the app display language into the signed-in instructor's profile so
 * backend-rendered emails (and new members' default language) speak it.
 * Fire-and-forget: a failed sync just retries on the next language change or
 * app load.
 */
const InstructorLanguageSync = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const currentLanguage = useAppSelector(selectCurrentLanguage);
  const lastSyncedLanguage = useRef<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !currentLanguage) {
      return;
    }
    if (lastSyncedLanguage.current === currentLanguage) {
      return;
    }
    lastSyncedLanguage.current = currentLanguage;
    dispatch(updateInstructorLanguage(currentLanguage));
  }, [dispatch, isAuthenticated, currentLanguage]);

  return null;
};

export default InstructorLanguageSync;
